import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SEOHreflang } from "@/components/seo/SEOHreflang";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <SEOHreflang canonicalUrl="https://roautomarket.ro/404" />
      <Helmet>
        <title>404 - Pagina nu a fost găsită | RO Auto Market</title>
        <meta name="description" content="Pagina nu exista. Intoarce-te la home pentru masini din Romania sau exploreaza categoriile disponibile." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://roautomarket.ro/404" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center p-8 max-w-md mx-auto">
          <h1 className="text-6xl font-bold mb-4 text-primary">404</h1>
          <h2 className="text-xl text-muted-foreground mb-6">Ups! Pagina nu a fost găsită</h2>
          <p className="text-sm text-muted-foreground mb-8">
            Pagina pe care o cauți nu există sau a fost mutată.
          </p>
          <div className="space-y-3">
            <Link 
              to="/" 
              className="inline-block w-full bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-lg font-medium transition-colors"
            >
              🏠 Înapoi la pagina principală
            </Link>
            <Link 
              to="/cars" 
              className="inline-block w-full border border-border hover:bg-accent px-6 py-3 rounded-lg font-medium transition-colors"
            >
              🚗 Caută mașini
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
